// formatCount.ts — compact display formatter for engagement counts (e.g. 1200 → "1.2K").
// Display-layer only; data stays numeric. Used by HeroPostCard's stats summary row.

export function formatCount(n: number): string {
  if (n < 1000) return String(n);
  if (n < 1_000_000) return trim(n / 1000) + 'K';
  return trim(n / 1_000_000) + 'M';
}

function trim(value: number): string {
  // One decimal place, dropping a trailing ".0" (1.0 → "1", 1.2 → "1.2").
  return value.toFixed(1).replace(/\.0$/, '');
}
